/**
 * @name AppLayout
 * @description Layout principal da aplicação - utiliza UserLayout
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import UserLayout from '@/components/layouts/UserLayout/UserLayout';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const AppLayout: React.FC = () => {
     return (
          <UserLayout>
               <Outlet />
          </UserLayout>
     );
};
